import { type LocaleDefinition } from '@solinkcorp/locale';
import { useSelector } from 'stores/store';
import LocaleUtil from 'utils/LocaleUtil';

/**
 * React hook which returns the current locale.
 * We fallback to the browser's locale for public routes if they're not wrapped in redux
 */

export default function useLocale(): LocaleDefinition {
  // Even though this is in a try catch, it doesn't break the hook rules of react
  // This is because the useSelector hook should always be called
  try {
    const localeCode = useSelector((state) => state.localeState.localeCode);
    return LocaleUtil.getLocale(localeCode);
  } catch {
    return LocaleUtil.getLocale(LocaleUtil.determineLocaleCode());
  }
}
